import { loadStoredSession } from "@itaas/core/auth/auth.storage";
import { notifyLowStockAlerts, notifyPrescriptionReady } from "@/core/hospitol-api-client";
import { pushLocalNotification } from "@/core/notifications/local-notifications";

/** Médecin → pharmacie : ordonnance en attente de préparation. */
export async function notifyPrescriptionSentToPharmacy(input: {
  prescriptionId: string;
  patientName: string;
}): Promise<void> {
  void input.prescriptionId;
  pushLocalNotification({
    title: "Nouvelle ordonnance",
    body: `${input.patientName} — en attente pharmacien`,
    targetRole: "HOSPITOL_PHARMACIST",
    actionUrl: "/tenant/hospitol/clinical/prescriptions",
    eventType: "prescription.sent",
  });
}

/** Pharmacien → dispensation autorisée. */
export async function notifyPrescriptionValidated(input: {
  prescriptionId: string;
  patientName: string;
}): Promise<void> {
  const userId = loadStoredSession()?.user?.id;
  pushLocalNotification({
    title: "Ordonnance validée",
    body: `Dispensation autorisée — ${input.patientName}`,
    targetUserId: userId,
    actionUrl: "/tenant/hospitol/pharmacy/invoice",
    eventType: "prescription.validated",
  });

  void notifyPrescriptionReady({
    prescriptionId: input.prescriptionId,
    patientName: input.patientName,
    recipientId: userId,
    tenantId: loadStoredSession()?.tenant?.slug,
  });
}

/** Alerte stock bas pour l'équipe pharmacie. */
export async function notifyPharmacyLowStock(input: {
  alerts: Array<{ productId: string; label: string; available: number; threshold: number }>;
}): Promise<void> {
  if (input.alerts.length === 0) return;

  const preview = input.alerts
    .slice(0, 2)
    .map((a) => a.label)
    .join(", ");

  pushLocalNotification({
    title: "Stock bas — pharmacie",
    body: preview,
    targetRole: "HOSPITOL_PHARMACIST",
    actionUrl: "/tenant/hospitol/supply/medicines/levels",
    eventType: "stock.low",
  });

  void notifyLowStockAlerts({
    alerts: input.alerts,
    recipientId: loadStoredSession()?.user?.id,
    tenantId: loadStoredSession()?.tenant?.slug,
  });
}
